module.exports = __webpack_public_path__ + "img/access.c2b1aa14.png";